<template>
	<div class="chartfilter__container">
		<div class="card__filter">
			<div
				style="
					display: flex;
					justify-content: space-between;
					align-items: center;
					padding-bottom: 0.5rem;
				"
			>
				<span class="filter__title">{{ $t('farms') }}</span>
				<p
					class="clear__button"
					@click="updateFazenda"
				>
					{{ $t('clear') }}
				</p>
			</div>
			<div class="filter__options__container">
				<div
					v-for="fazenda in filters.fazendas"
					:key="fazenda.id"
					class="filter__option"
				>
					<Checkbox
						:id="fazenda.id"
						:label="fazenda.nome"
						:value="fazenda.id"
						:checked="fazendas.includes(fazenda.id)"
						@click="updateFazenda"
					/>
				</div>
			</div>
		</div>
		<div class="card__filter">
			<div
				style="
					display: flex;
					justify-content: space-between;
					align-items: center;
					padding-bottom: 0.5rem;
				"
			>
				<span class="filter__title">{{ $t('spacing') }}</span>
				<p
					class="clear__button"
					@click="updateEspacamento"
				>
					{{ $t('clear') }}
				</p>
			</div>
			<div class="filter__options__container">
				<div
					v-for="esp in filters.espacamentos"
					:key="esp"
					class="filter__option"
				>
					<Checkbox
						:label="esp"
						:value="esp"
						:checked="espacamento.includes(esp)"
						@click="updateEspacamento"
					/>
				</div>
			</div>
		</div>
		<div class="card__filter">
			<div
				style="
					display: flex;
					justify-content: space-between;
					align-items: center;
					padding-bottom: 0.5rem;
				"
			>
				<span class="filter__title">{{ $t('geneticMaterial') }}</span>
				<p
					class="clear__button"
					@click="updateMaterial"
				>
					{{ $t('clear') }}
				</p>
			</div>
			<div class="filter__options__container">
				<div
					v-for="matgen in filters.materiaisGenetico"
					:key="matgen"
					class="filter__option"
				>
					<Checkbox
						:label="matgen"
						:value="matgen"
						:checked="material.includes(matgen)"
						@click="updateMaterial"
					/>
				</div>
			</div>
		</div>
		<div class="card__filter">
			<div v-if="dashboardStore.state.customizada">
				<div
					style="
						display: flex;
						justify-content: space-between;
						align-items: center;
						padding-bottom: 0.5rem;
					"
				>
					<span class="filter__title">
						{{ dashboardStore.state.customizada }}
					</span>
					<div style="display: flex; gap: 1rem; align-items: center">
						<i
							title="Trocar variável"
							class="far fa-trash-alt"
							style="font-size: 0.8rem; cursor: pointer"
							@click="limparVariavelCustomizada"
						/>
						<p
							class="clear__button"
							@click="updatePlantio"
						>
							{{ $t('clear') }}
						</p>
					</div>
				</div>
				<div class="filter__options__container">
					<div
						v-for="ptio in filters.plantios"
						:key="ptio"
						class="filter__option"
					>
						<Checkbox
							:label="`${ptio} ${
								plantio.indexOf(ptio) > -1 ? '(' + (plantio.indexOf(ptio) + 1) + ')' : ''
							}`"
							:value="ptio"
							:checked="plantio.includes(ptio)"
							@click="updatePlantio"
						/>
					</div>
				</div>
			</div>
			<div v-else>
				<ButtonDropdown
					v-model="customizadaEscolhida"
					:options="
						options.map((m) => {
							return { value: m, label: m }
						})
					"
					label="Configurar uma variável"
				/>
			</div>
		</div>
	</div>
</template>

<script setup>
import { toRefs, watch, ref } from 'vue'
import Checkbox from '../Checkbox/Checkbox.vue'
import ButtonDropdown from '../ButtonDropdown/ButtonDropdown.vue'
import { useStore } from '../../store/modules/moduleDashboardAnalytics'
const dashboardStore = useStore()

const props = defineProps({
	fazendas: { type: Array, default: () => [] },
	espacamento: { type: Array, default: () => [] },
	material: { type: Array, default: () => [] },
	plantio: { type: Array, default: () => [] },
	filters: { type: Object },
	options: { type: Array, default: () => [] },
})

// const customizada = useLocalStorage("customizada", "");
const customizadaEscolhida = ref(undefined)

watch(customizadaEscolhida, (value) => {
	dashboardStore.commit('setCustomizada', value)
})

// Quando a variável customizada for limpa externamente, resetar o dropdown
watch(
	() => dashboardStore.state.customizada,
	(value) => {
		if (!value) {
			customizadaEscolhida.value = undefined
		}
	},
)

const { fazendas, espacamento, material, plantio } = toRefs(props)

const emit = defineEmits([
	'update:fazendas',
	'update:espacamento',
	'update:material',
	'update:plantio',
])

function updateFazenda(event) {
	const value = event.target.value
	if (value) {
		if (fazendas.value.includes(value)) {
			fazendas.value.splice(fazendas.value.indexOf(value), 1)
		} else {
			fazendas.value.push(value)
		}
	} else {
		fazendas.value.splice(0, fazendas.value.length)
	}
	emit('fazendas', fazendas.value)
}

function updateEspacamento(event) {
	const value = event.target.value

	if (value) {
		if (espacamento.value.includes(value)) {
			espacamento.value.splice(espacamento.value.indexOf(value), 1)
		} else {
			espacamento.value.push(value)
		}
	} else {
		espacamento.value.splice(0, espacamento.value.length)
	}

	emit('espacamento', espacamento.value)
}

function updateMaterial(event) {
	const value = event.target.value

	if (value) {
		if (material.value.includes(value)) {
			material.value.splice(material.value.indexOf(value), 1)
		} else {
			material.value.push(value)
		}
	} else {
		material.value.splice(0, material.value.length)
	}
	emit('material', material.value)
}
function updatePlantio(event) {
	const value = event.target.value

	if (value) {
		if (plantio.value.includes(value)) {
			plantio.value.splice(plantio.value.indexOf(value), 1)
		} else {
			plantio.value.push(value)
		}
	} else {
		plantio.value.splice(0, plantio.value.length)
	}
	emit('plantio', plantio.value)
}

function limparVariavelCustomizada() {
	// Limpa os filtros de plantio
	plantio.value.splice(0, plantio.value.length)
	emit('plantio', plantio.value)

	// Limpa a variável customizada no store
	dashboardStore.commit('setCustomizada', '')
}
</script>

<style scoped>
.card__filter {
	background: var(--color-background-card-info);
	border: 1px solid #e6e6e6;
	border-radius: 2px;
	padding: 0.875rem;
	gap: 0.5rem;
	display: flex;
	flex-direction: column;
}

.chartfilter__container {
	max-width: 20%;
	display: flex;
	gap: 1rem;
	flex-direction: column;
}

.filter__options__container {
	display: flex;
	flex-wrap: wrap;
	gap: 0.5rem;
}

.filter__option {
	min-width: 45%;
}
.filter__title {
	color: var(--color-base-secondary);
	font-weight: 700;
	font-size: 0.875;
}
</style>
<style>
.container__checkbox__label.text {
	font-size: 0.875rem !important;
	color: #4b4b4d !important;
}

.clear__button {
	font-weight: 400;
	cursor: pointer;
	font-size: 0.8rem;
	margin-bottom: 0 !important;
}

.clear__button:hover {
	text-decoration: underline;
}

.far.fa-trash-alt:hover {
	color: var(--color-error-indicator);
}
</style>
